import { PureComponent } from 'react';
import moment from 'moment'
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { Settings } from '@dbk/ui-icons';
import { TextInput, NumericInput, Radio, Message } from '@dbk/ui-forms';
import Select from '@dbk/ui-select';
import Text from '@dbk/ui-text';
import { DatePicker } from '@dbk/ui-datepicker';
import InverseProvider from '@dbk/ui-inverse';
import 'moment/min/locales';
import { PALETTE, KEY_CODE, PAYMENT_DATE_TYPE } from '../../../../constants';
import { convertStringArrayToObjectArray as convert, convertAndSortDropDown, convertKeyToLabelArray, convertKeyToLabelArrayForInitiator, convertCurrencyDropdown } from '../../payment-utils';
import BlurModal from '../../../../components/common/blur-modal';
import { LoadingCircle } from '../../../../components/common/loading';
import { today, weekAgo, monthAgo, formatToISODate, formatDateShortMonth } from '../../../../utils/date';
import {
  FILTER_ICON_STYLE,
  PAYMENT_RANGE_TODAY,
  PAYMENT_RANGE_ONE_WEEK,
  PAYMENT_RANGE_ONE_MONTH,
  PAYMENT_RANGE_RANGE,
  PAYMENT_RANGE_OPTIONS
} from '../../constant';

const initOpts = {
  currencyList: [],
  portfolioList: [],
  debitAccountList: [],
  beneficiaryName: '',
  paymentTypeList: [],
  paymentStatusList: [],
  initiatorList: [],
  selectedExecDate: '',
  execFromDate: null,
  execToDate: null,
  amountFrom: '',
  amountTo: '',
  filters: ['selectedDate'],
  showFilter: false,
  isDateRangeActive: false,
  selectedDate: PAYMENT_DATE_TYPE.EXECUTION_DATE
}
const clearedFilters = {
  selectedExecDate: '',
  execFromDate: '',
  execToDate: '',
  showFilter: true,
  dateRange: { from: null, to: null },
}

class PaymentFilter extends PureComponent {
  constructor(props) {
    super(props);
  }

  initialState = Object.assign(
    {
      refetching: false,
      debitAccountListData: null,
      dateRange: {
        from:
          this.props.payments.filterOptions?.execFromDate
            ? moment(this.props.payments.filterOptions.execFromDate).toDate()
            : this.props.payments.filterOptions?.conclusionFromDate
              ? moment(this.props.payments.filterOptions.conclusionFromDate).toDate()
              : null,
        to: this.props.payments.filterOptions?.execToDate
          ? moment(this.props.payments.filterOptions.execToDate).toDate()
          : this.props.payments.filterOptions?.conclusionToDate
            ? moment(this.props.payments.filterOptions.conclusionToDate).toDate()
            : null,
      },
      selectedDay: moment(this.props.payments.startDate),
    },
    initOpts,
    this.props.payments.filterOptions
  );

  // Assign to state
  state = { ...Object.assign({}, this.initialState) };


  componentDidUpdate() {
    if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen) {
      this.onCancel();
    }
    if (document.querySelector('input.searchInput') && this.state.beneficiaryName) {
      document.querySelector('input.searchInput').focus();
      return;
    }
    if (this.state.dateRange.from && this.state.dateRange.to && this.state.selectedExecDate === 'range') {
      setTimeout(() => {
        if (document.querySelector('#applybtnFocus')) {
          document.querySelector('#applybtnFocus').focus();
        }
        this.setState({ isDateRangeActive: true });
      }, 100);
    }
  }

  onCancel = () => {
    this.datepickerRef.close();
    this.props.setDatePickerClose(false);
  }


  onFilterChange = (selectedItem, selectedItems, key) => {
    this.setState({ [key]: selectedItems })
    this.setFilter(key, selectedItem, selectedItems)
  }

  onPortfolioChange = (option) => {
    const { payments } = this.props;
    this.onFilterChange('portfolio', option);
    const debitAccountListData = option != "" ? payments.debitAccountListData.filter((p) => p.pfId.includes(option)) : payments.debitAccountListData;
    this.setState({ debitAccountListData }, function () {
      const debitIndex = findIndex(debitAccountListData, (p) => p.psActNo === this.state.debitAccount);
      if (debitIndex == -1)
        this.onFilterChange('debitAccount', '');
    });
  }
  onClearClick = () => {
    const { payments: { debitAccountListData } } = this.props;
    this.setState(prevState => ({
      ...initOpts,
      ...clearedFilters,
      debitAccountListData
    }))
  }
  onAmountChange = ({ min, max }) => {
    this.setState({ amountFrom: min })
    this.setState({ amountTo: max })
  }
  onApplyClick = () => {
    const { payments: { setFilterOptions } } = this.props;
    const {
      filters, execFromDate, execToDate, selectedExecDate, conclusionFromDate, conclusionToDate } = this.state;
    const options = {};
    options.selectedExecDate = selectedExecDate;
    let localFilter = this.state.filters;
    for (const filter of filters) {
      if (filter === 'date') {
        if (selectedExecDate === 'range') {
          if ((this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE) && (execFromDate && execToDate)) {
            options.execFromDate = formatToISODate(execFromDate);
            options.execToDate = formatToISODate(execToDate);
          } else if (conclusionFromDate && conclusionToDate) {
            options.conclusionFromDate = formatToISODate(conclusionFromDate);
            options.conclusionToDate = formatToISODate(conclusionToDate);
          } else {
            localFilter = localFilter.filter(f => f !== 'date');
            // this.setState(prevState => ({
            //   filters: prevState.filters.filter(f => f !== 'date'),
            //   selectedExecDate: ''
            // }));
          }
        } else {
          if (this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE) {
            options.execFromDate = execFromDate
            options.execToDate = execToDate
          } else {
            options.conclusionFromDate = conclusionFromDate
            options.conclusionToDate = conclusionToDate
          }
        }
      } else {
        options[filter] = this.state[filter];
      }
    }
    options.filters = localFilter;
    setFilterOptions(options);
 
    const opts = { ...options };
    const arrayObj = Object.fromEntries(
      Object.entries(opts)
        .filter(([key, value]) => key !== 'filters' && Array.isArray(value))
        .map(([key, arr]) => [key, arr.map(item => item.key)])
    );
 
    const otherFilterObj = Object.fromEntries(
      Object.entries(opts)
        .filter(([key, value]) => !Array.isArray(value) && key !== 'selectedDate' &&
          key !== 'selectedExecDate')
    );
 
    const filterLookupObj = { ...arrayObj, ...otherFilterObj };
    this.props.payments.applyFilter(filterLookupObj);
    this.toggleFilter(false, options);
  }

  setSelectionDateType = execDate => {
    let execFromDate;
    let filterFromDate = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'execFromDate' : 'conclusionFromDate';
    let filterToDate = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'execToDate' : 'conclusionToDate';
    //  //WMCE-45985- to resolve the filter on date for german language
    if (execDate === PAYMENT_RANGE_TODAY) {
      execFromDate = today
    } else if (execDate === PAYMENT_RANGE_ONE_WEEK) {
      execFromDate = weekAgo
    } else if (execDate === PAYMENT_RANGE_ONE_MONTH) {
      execFromDate = monthAgo
    }
    if (execDate !== PAYMENT_RANGE_RANGE) {
      this.setState({
        isDateRangeActive: false,
        selectedExecDate: execDate,
        [filterFromDate]: execFromDate,
        [filterToDate]: today,
        dateRange: {
          from: execFromDate ? moment(execFromDate).toDate() : null,
          to: moment().toDate()
        }
      });
    } else {
      this.setState({
        selectedExecDate: execDate,
        isDateRangeActive: true,
        dateRange: {
          from: null,
          to: null
        }
      })
    }
    if (!this.state.filters.includes('date')) {
      this.setState(prevState => ({
        ...prevState,
        filters: prevState.filters.concat('date')
      }))
    }
  }

  setExecDate = execDate => {
    let execFromDate
    if (execDate === 'today') {
      execFromDate = today
    } else if (execDate === 'oneWeek') {
      execFromDate = weekAgo
    } else if (execDate === 'oneMonth') {
      execFromDate = monthAgo
    }
    if (execDate !== 'range') {
      this.setState({
        isDateRangeActive: false,
        selectedExecDate: execDate,
        execFromDate,
        execToDate: today,
        dateRange: {
          from: execFromDate ? moment(execFromDate).toDate() : null,   //WMCE-53265-Fix for web app crashing
          to: moment().toDate()
        }
      });
    } else {
      this.setState({
        selectedExecDate: execDate,
        isDateRangeActive: true,
        dateRange: {
          from: null,
          to: null
        }
      })
    }
    if (!this.state.filters.includes('date')) {
      this.setState(prevState => ({
        ...prevState,
        filters: prevState.filters.concat('date')
      }))
    }
  }
  setFilter = (filterType, value, selectedItems) => {
    const { filters } = this.state;
    let updatedFilters = [...filters];

    if (!updatedFilters.includes(filterType)) {
      updatedFilters.push(filterType);
    } else if (selectedItems.length === 0) {
      updatedFilters = updatedFilters.filter(f => f !== filterType);
    }
    this.setState({ filters: updatedFilters });
  }
  refetch = async (e) => {
    if ((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)) {
      console.log("in refetch...");
      if (this.state.refetching || this.props.payments.transactionListLoading) return;
      this.setState({ refetching: true })
      await this.props.payments.getPaymentHistory('refetch');
      setTimeout(() => {
        this.setState({ refetching: false })
      }, 100);
    }
  }
  toggleFilter = (show, options, e) => {
    if ((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)) {
      this.setState({ showFilter: show }, async function () {
        if (show) {
          this.props.payments.fetchSubmittedFilterListLookup();
        }
        else {
          const filterOptions = (options.filters) ? options : this.props.payments.filterOptions;
          const obj = Object.assign(
            {},
            initOpts,
            filterOptions)
          this.setState({
            ...obj,
            filters: filterOptions ? filterOptions.filters : ['amount']
          })
        }
      })
      setTimeout(() => {
        if (document.querySelector('button.paymentFilterFocus')) {  // Button focusable for payment filter popup
          document.querySelector('button.paymentFilterFocus').focus();
        }
      }, 1000)
    }
  }

  hideDateRangeModal = () => {
    const { execFromDate, execToDate } = this.state;
    this.setState(() => ({
      // isDateRangeActive: false,
      dateRange: {
        from: execFromDate ? moment(execFromDate).toDate() : null,
        to: execToDate ? moment(execToDate).toDate() : null
      }
    }));
    this.datepickerRef.close();
    // this.datepickerRef.handleClose();
  };

  renderSelectDropdown = ({
    label,
    stateKey,
    options,
    onChange
  }) => {
    const {
      i18n: { messages }
    } = this.props;
    return (
      <div className="columns large-6">
        <div className='margin-bottom-5'>
          <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}>{label}</Text>
        </div>
        <div>
          <Select
            tabIndex='0'
            size='large'
            defaultLabel={messages['app.common.select']}
            selectedItems={this.state[stateKey]}
            options={options}
            fullWidth
            onChange={onChange || ((selectedItem, selectedItems) =>
              this.onFilterChange(selectedItem, selectedItems, stateKey)
            )}
            labelForReader={label}
          // accessible label to be added
          />
        </div>
      </div>
    );
  }
  onDateApply = () => {
    let date = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'exec' : 'conclusion';
    const { dateRange } = this.state;
    this.setState({
      [date + 'FromDate']: dateRange.from ? formatDateShortMonth(dateRange.from) : null,
      [date + 'ToDate']: dateRange.to ? formatDateShortMonth(dateRange.to) : null,
    });
    this.datepickerRef?.close();
  }

  onChangeRange = (range) => {
    this.setState({
      dateRange: {
        ...this.state.dateRange,
        ...range
      }
    });
  };


  customFooter = () => {
    const { i18n: { messages } } = this.props;
    const { dateRange: { from, to } } = this.state;
    return <InverseProvider inverse className="customFooterParent">
      <div className="datepicker-footer-txt" tabIndex={0}>
        <Text className="customFooterToday">{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className="datepicker-footer-btn">
        <Button tertiary
          onClick={() => this.hideDateRangeModal()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
          id="applybtnFocus"
          onClick={() => this.onDateApply()}
          disabled={!(from && to)}
        >{messages['app.reports.orderReport.accountPortfolioPlaceholder']}</Button>
      </div>
    </InverseProvider>
  }

  onCancel = () => {
    this.datepickerRef.close();
  }

  setSelectionDateType = execDate => {
    let execFromDate;
    let filterFromDate = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'execFromDate' : 'conclusionFromDate';
    let filterToDate = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'execToDate' : 'conclusionToDate';
    //  //WMCE-45985- to resolve the filter on date for german language
    if (execDate === PAYMENT_RANGE_TODAY) {
      execFromDate = today
    } else if (execDate === PAYMENT_RANGE_ONE_WEEK) {
      execFromDate = weekAgo
    } else if (execDate === PAYMENT_RANGE_ONE_MONTH) {
      execFromDate = monthAgo
    }
    if (execDate !== PAYMENT_RANGE_RANGE) {
      this.setState({
        isDateRangeActive: false,
        selectedExecDate: execDate,
        [filterFromDate]: execFromDate,
        [filterToDate]: today,
        dateRange: {
          from: execFromDate ? moment(execFromDate).toDate() : null,
          to: moment().toDate()
        }
      });
    } else {
      this.setState({
        selectedExecDate: execDate,
        isDateRangeActive: true,
        dateRange: {
          from: null,
          to: null
        }
      })
    }
    if (!this.state.filters.includes('date')) {
      this.setState(prevState => ({
        ...prevState,
        filters: prevState.filters.concat('date')
      }))
    }
  }
  onCloseModal = () => {
    this.setState({ showFilter: false, ...this.initialState });
  }

  renderDateRangeOptionBtns = (key) => (
    <div className="btn_seg columns large-3">
      <Button
        tabIndex={0}
        className="paymentFilterFocus"
        tertiary={this.state.selectedExecDate !== key}
        fullWidth
        onPress={() => this.setSelectionDateType(key)}
      >
        {this.props.i18n.messages['app.payment.filter.' + key]}
      </Button>
    </div>
  );
  onRadioSelectedViewByDate = (value) => {
    const { selectedExecDate } = this.state;
    this.setState({
      selectedDate: value
    }, function () {
      if (selectedExecDate === 'range') this.onDateApply()
      if (selectedExecDate != '') this.setSelectionDateType(selectedExecDate)
    })
    this.setFilter('selectedDate', '', value);
  }

  getFilterCount = () => {
    const filters = this.state.filters;
    let count = 0;
    if (filters.includes('amountFrom') || filters.includes('amountTo')) {
      count += 1;
    }
    if (filters.includes('selectedDate') && filters.includes('date')) {
      count += 1;
    }
    const otherFilters = filters.filter(f => f !== 'amountFrom' && f !== 'amountTo' && f !== 'selectedDate' && f !== 'date');
    count += otherFilters.length;
    return count;
  }

  render() {
    const {
      i18n: { messages },
      payments: {
        portfolioListData,
        paymentTypeListData,
        currencyListData,
        statusListData,
        debitAccountListData,
      },} = this.props;
    const {
      beneficiaryName,
      showFilter,
      dateRange,
    } = this.state;


    const isLoaded = portfolioListData && this.props.payments.debitAccountListData && paymentTypeListData && currencyListData && statusListData;
    const filterCount = this.getFilterCount();

    const currencyData = convertCurrencyDropdown(currencyListData);
    const portfolioData = convert(portfolioListData);
    const debitAccountData = convertAndSortDropDown((debitAccountListData || this.props.payments.debitAccountListData), ["psActNo", "psPosId", "pfId"]);
    const paymentTypeData = convertKeyToLabelArray(paymentTypeListData);
    const paymentStatusData = convertKeyToLabelArray(statusListData);
    const pageTitle = `${messages['app.payment.pageTitle.filterPayment']} (${filterCount})`;
    return (
      <>
        <span className={'paymentListFilter pointer flex-ai-center margin-left-15'} role="button" onKeyDown={(e) => this.toggleFilter(true, "", e)} onClick={() => this.toggleFilter(true)} tabIndex="0" aria-label={messages['app.payment.filterButton']}>
          <Settings id="filter" width={FILTER_ICON_STYLE.WIDTH} height={FILTER_ICON_STYLE.HEIGHT} color={filterCount > 0 ? PALETTE.primaryActive : PALETTE.secondaryActive} />
          <Text className='paymentFilterBadge'> {filterCount > 0 && `(${filterCount})`}</Text>
        </span>
        <BlurModal
          onDone={() => {
            this.setState({ showFilter: false }, this.onCloseModal())
          }}
          visible={showFilter}
          type="xdark"
          size="large"
          title={pageTitle}
          className={"filter-modal-payments"}
        >
          <div className="payment-filter-input">
            {!isLoaded && <LoadingCircle />}
            {isLoaded && <div className="row" >
              <div className="columns large-12 pymntFilterContentBgCol">
                <div className="row">
                  <Text className="columns large-12 margin-bottom-10"  tabIndex="0" aria-label={messages['app.payment.filter.pymtExecDateFilter']}> {messages['app.payment.filter.pymtExecDate']} </Text>
                </div>
                <div className="row">
                  {PAYMENT_RANGE_OPTIONS.map(key => this.renderDateRangeOptionBtns(key))}
                  {this.state.isDateRangeActive &&
                    <div className="paymentFilter input-container" aria-label={messages['app.payment.dateRangeCalender']} >
                      <DatePicker
                        aria-label={messages['app.payment.dateRangeCalender']}
                        ref={(ref) => this.datepickerRef = ref}
                        tetherProps={{ attachment: "top center", targetAttachment: "bottom center" }}
                        showOutsideMonthDays={false}
                        enableYearNavigation
                        enableRangeSelection
                        onChange={this.onChangeRange}
                        value={dateRange}
                        startDate={moment().add(-2, 'years').toDate()}
                        endDate={moment().add(4, 'years').toDate()}
                        inputDateFormat={'dd MMM yyyy'}
                        selectionStart={dateRange.from}
                        selectionEnd={dateRange.to}
                        disableWeekendDays
                        renderFooter={() => this.customFooter()}
                        locale={this.props.auth.langCode}
                        weekStartsOn={1} // Monday is the first day of the week.
                      />
                    </div>
                  }
                </div>
                <div className="row filterRowsMargin">
                  <div className='columns margin-bottom-5'>
                    <Text tabIndex={0}> {messages['app.payment.filter.pymtAmount']} </Text>
                  </div>
                </div>
                <div className="row filterRowsMargin">
                  <div className="columns large-6">
                    <div className='margin-bottom-5'>
                      <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}> {messages['app.payments.destination.from']} </Text>
                    </div>
                    <div>
                      <NumericInput
                        tabIndex="0"
                        value={this.state.amountFrom}
                        size="large"
                        placeholder={messages['app.payment.filter.amount.range.start']}
                        placeholderTextColor={PALETTE.primaryText}
                        onChange={text => this.onFilterChange(text.target.value, text.target.value, 'amountFrom')}

                      />
                    </div>

                  </div>
                  <div className="columns large-6">
                    <div className='margin-bottom-5'>
                      <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}> {messages['app.payments.destination.to']} </Text>
                    </div>
                    <div>
                      <NumericInput
                        tabIndex="0"
                        value={this.state.amountTo}
                        size="large"
                        placeholder={messages['app.payment.filter.amount.range.end']}
                        placeholderTextColor={PALETTE.primaryText}
                        error={this.state.error}
                        onBlur={this.handleAmountRangeBlur}
                        onChange={text => this.onFilterChange(text.target.value, text.target.value, 'amountTo')}
                      />
                      {this.state.error &&
                        <Message type="error">
                          {messages['app.payment.filter.amount.range.error']}
                        </Message>
                      }
                    </div>
                  </div>
                </div>
                <div className="row filterRowsMargin">
                  {this.renderSelectDropdown({
                    label: messages['app.payment.filter.pymtCurrency'],
                    stateKey: 'currencyList',
                    options: currencyData
                  })}
                  {this.renderSelectDropdown({
                    label: messages['app.payment.filter.portfolio'],
                    stateKey: 'portfolioList',
                    options: portfolioData
                  })}
                </div>
                <div className="row filterRowsMargin">
                  {this.renderSelectDropdown({
                    label: messages['app.payment.filter.debitAccount'],
                    stateKey: 'debitAccountList',
                    options: debitAccountData
                  })}
                  <div className="columns large-6 ">
                    <div className='margin-bottom-5'>
                      <Text secondary className=" paymentHeading" tabIndex={0}> {messages['app.payment.filter.beneName']} </Text>
                    </div>
                    <div>
                      <TextInput
                        tabIndex="0"
                        value={beneficiaryName}
                        size="small"
                        onChange={text => this.onFilterChange(text.target.value, text.target.value, 'beneficiaryName')}
                        className="searchInput"
                        title={messages['app.payment.filter.beneName']}
                      />
                    </div>
                  </div>
                </div>
                <div className="row filterRowsMargin">
                  {this.renderSelectDropdown({
                    label: messages['app.payment.filter.pymtType'],
                    stateKey: 'paymentTypeList',
                    options: paymentTypeData
                  })}

                  {this.renderSelectDropdown({
                    label: messages['app.payment.filter.pymtStatus'],
                    stateKey: 'paymentStatusList',
                    options: paymentStatusData
                  })}
                </div>
                <div className="row ">
                  <div className="btn">
                    <Button size="large" onPress={this.onApplyClick}>
                      {messages['app.payment.filter.applyButton']}
                    </Button>
                  </div>
                  <div className="btn">
                    <Button size="large" tertiary onPress={this.onClearClick}>
                      {messages['app.payment.filter.clearButton']}
                    </Button>
                  </div>
                </div>
              </div>
            </div>}
          </div>
        </BlurModal>
      </>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    payments: {
      getPaymentHistory: { $call: 'getPaymentHistory' },
      transactionListLoading: true,
      setFilterFlag: { $set: 'filterFlag' },
      portfolioListData: true,
      debitAccountListData: true,
      paymentTypeListData: true,
      statusListData: true,
      currencyListData: true,
      filterOptions: true,
      applyFilter: { $call: 'applyFilter' },
      setFilterOptions: { $set: 'filterOptions' },
      setFilteredPayments: { $set: 'filteredPayments' },
      fetchSubmittedFilterListLookup: { $call: 'fetchSubmittedFilterListLookup' }
    },
    auth: {
      langCode: true,
    },
    reports: {
      closeDatePicker: true
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
  },
}
)(PaymentFilter);
